import { useState } from "react";
import { toast } from "sonner";

import { ChalkActionButton, SectionTitle } from "../chalk/primitives";
import { tournaments } from "../../lib/tournamentApi";
import RulesEditor from "./RulesEditor";
import { inputStyle, pillBtn } from "./shared";

const FORMATS = [["single_elim", "Single elimination"], ["pools", "Pool play → bracket"], ["double_elim", "Double elimination"]];

export default function FormatEditor({ data, division, onChanged }) {
  const t = data.tournament;
  const d = division;
  const locked = d.bracket_locked;
  const [pc, setPc] = useState(d.pool_config);
  async function save(body, ok = "Saved.") {
    try { await tournaments.setFormat(t.id, d.id, body); toast.success(ok); await onChanged(); }
    catch (e) { toast.error(e.message || "Couldn't save."); }
  }
  const num = (k, label) => (
    <label style={{ fontSize: 11, fontWeight: 700, color: "var(--chalk-muted)" }}>{label}
      <input type="number" value={pc[k]} disabled={locked} data-testid={`pool-config-${k}`}
             onChange={(e) => setPc({ ...pc, [k]: Number(e.target.value) })} style={{ ...inputStyle, marginTop: 4 }} />
    </label>
  );
  return (
    <div data-testid={`format-editor-${d.id}`} style={{ background: "#FBF8F2", borderRadius: 12, padding: 12, margin: "6px 0 12px" }}>
      <SectionTitle label={`${d.name} — format`} />
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {FORMATS.map(([k, l]) => (
          <button key={k} disabled={locked} data-testid={`format-${k}`} onClick={() => save({ format: k })}
                  style={pillBtn(d.format === k, "var(--green-mid)")}>{l}</button>
        ))}
      </div>
      {d.format !== "double_elim" && (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 8 }}>
          {[["none", "No consolation"], ["first_game", "Consolation (first-game losers)"], ["third_place", "3rd-place game"]]
            .filter(([k]) => d.format === "single_elim" || k !== "first_game")
            .map(([k, l]) => (
              <button key={k} disabled={locked} data-testid={`consolation-${k}`} onClick={() => save({ consolation: k })}
                      style={pillBtn(d.consolation === k)}>{l}</button>
            ))}
        </div>
      )}
      {d.format === "double_elim" && (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 8 }}>
          {[["if_necessary", "True double elim (if-necessary game)"], ["one_game", "One-game final"]].map(([k, l]) => (
            <button key={k} disabled={locked} data-testid={`grand-final-${k}`} onClick={() => save({ grand_final: k })}
                    style={pillBtn(d.grand_final === k)}>{l}</button>
          ))}
        </div>
      )}
      {d.format === "pools" && (
        <div style={{ marginTop: 10 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
            {num("pool_count", "Pools")}{num("advance_per_pool", "Advance / pool")}{num("wildcards", "Wildcards")}
          </div>
          <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, margin: "8px 0" }}>
            <input type="checkbox" checked={pc.silver} disabled={locked} data-testid="pool-config-silver"
                   onChange={(e) => setPc({ ...pc, silver: e.target.checked })} /> Silver bracket for teams that don't advance
          </label>
          {!locked && <ChalkActionButton label="Save pool settings" variant="ghost" testId="pool-config-save"
                                         onClick={() => save({ pool_config: pc })} />}
        </div>
      )}
      <div style={{ marginTop: 10 }}>
        <RulesEditor title="Division sport & rules" sport={d.sport || ""} rules={d.rules} sports={data.sports} locked={locked}
                     allowInherit testPrefix={`div-rules-${d.id}`} onSave={(body) => save(body, "Rules saved.")} />
      </div>
    </div>
  );
}
